import ChartMixin from "@/components/Charts/mixins/bar-chart";

export default {
	name: "DriversReportAverageIdleChart",

	mixins: [ ChartMixin ],

	props: {
		item: Object,
		items: Array
	},

	data: () => ( {
		averageObjectValuePath: "stats.idleTime.average",
		title: "Avg. Idle Duration",
		yAxisLabel: "Duration (Minutes)"
	} ),

	computed: {
		itemsAverageValue() {
			if ( this.averageValue ) {
				return ( this.averageValue / 60 ).toFixed( 1 );
			}
		},

		barData() {
			if ( this.item ) {
				return [
					( this.item.stats.idleTime.average / 60 ).toFixed( 1 ),
					this.itemsAverageValue
				];
			}

			return this.items.map( item =>
				( item.stats.idleTime.average / 60 ).toFixed( 1 )
			);
		},

		labels() {
			if ( this.item ) {
				return [
					this.item.driver.user.name.split( " " ),
					[ "All drivers", "average" ]
				];
			}

			return this.items.map( item => item.driver.user.name );
		}
	}
};
